import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import ResponsiveFrame from '../../../components/ResponsiveFrame';

const PreviewFrame = ({ currentDevice, isRotated, content }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300);
    return () => clearTimeout(timer);
  }, [currentDevice, isRotated]);

  // Размеры устройств
  const getDeviceDimensions = () => {
    if (currentDevice === 'desktop') {
      return { width: '100%', height: '100%' };
    }

    if (currentDevice === 'tablet') {
      return isRotated
        ? { width: '1024px', height: '768px' }
        : { width: '768px', height: '100%' };
    }

    if (currentDevice === 'mobile') {
      return isRotated
        ? { width: '667px', height: '375px' }
        : { width: '375px', height: '100%' };
    }

    return { width: '100%', height: '100%' };
  };

  const dimensions = getDeviceDimensions();
  const isFullWidth = currentDevice === 'desktop';

  return (
    <div className="flex-1 bg-muted p-4 md:p-6 lg:p-8 overflow-auto">
      {isLoading ? (
        <div className="flex items-center justify-center h-full">
          <div className="text-center">
            <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-text-secondary">Загрузка...</p>
          </div>
        </div>
      ) : isFullWidth ? (
        // Desktop - рендерим напрямую
        <div className="bg-background min-h-full shadow-lg rounded-lg overflow-hidden">
          {content}
        </div>
      ) : (
        // Tablet/Mobile - используем iframe для правильных media queries
        <div className="flex justify-center">
          <div
            className="bg-background shadow-lg rounded-lg overflow-hidden transition-all duration-300"
            style={{
              width: dimensions.width,
              maxWidth: '100%',
              height: dimensions.height === '100%' ? 'calc(100vh - 250px)' : dimensions.height
            }}
          >
            <ResponsiveFrame width="100%" height="100%">
              {content}
            </ResponsiveFrame>
          </div>
        </div>
      )}
    </div>
  );
};

export default PreviewFrame;
